import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import JobService from "@/core/services/job.service.ts";
import SidebarService from "@/core/services/sidebar.service.ts";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class JobComponent extends Vue {
  // Service's Instance
  jobService: any = new JobService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  modal: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  searchFlag: any = [];
  jobList: any = [];
  filterJobList: any = [];
  companyList: any = [];
  name: string = "";
  search: string = "";
  company: string = "";
  companies: string = "";
  jobToDelete: any;
  searchByDate: any = "";
  createdAt: string = "";
  filterConcatDate: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfJob: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;
  isTrainingSuperAdmin: boolean = false;

  mounted() {
    const _ = this;
    _.get(_.pageOffset, _.itemsPerPage);
    _.filterDate();
    _.isTrainingAdmin();
  }

  filterByDate() {
    const _ = this;
    _.deleteIcon = true;
    let day =
      _.searchByDate.getDate() < 10
        ? "0" + _.searchByDate.getDate()
        : _.searchByDate.getDate();
    let month =
      _.searchByDate.getMonth() < 10
        ? "0" + (_.searchByDate.getMonth() + 1)
        : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    _.filterJobList = _.jobList.filter((job) => {
      let parseDate: any = job.createdAt.split("T");
      parseDate = parseDate[0];
      return _.filterConcatDate == parseDate;
    });
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterJobList = _.jobList;
      return;
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id) {
    const _ = this;
    _.jobToDelete = id;
    _.modal = true;
  }

  get(pageOffset = 0, itemsPerPage = 50) {
    const _ = this;
    console.log(pageOffset, itemsPerPage);
    _.isLoading = false;
    _.jobService
      .get(pageOffset, itemsPerPage)
      .then((data: any) => {
        console.log(data);
        _.jobList = data["data"].jobs;
        _.filterJobList = data["data"].jobs;
        console.log(data);
        _.totalOfJob = data["data"].total;
        _.totalPages = Math.ceil(_.totalOfJob / itemsPerPage);
        console.log(_.totalPages, "totalPages");
        if (_.totalPages <= 1) {
          _.pagination = false;
        }
        if (pageOffset == 0) {
          _.itemsOfFrom = 1;
          _.itemsOfTo = _.jobList.length;
          _.previousPositionDisabled = true;
          console.log(_.itemsOfTo, "555");
        }
        if (pageOffset != 0) {
          _.previousPositionDisabled = false;
        }
        if (pageOffset == _.totalPages - 1) {
          _.itemsOfTo = _.totalOfJob;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  delete_job() {
    const _ = this;
    _.isLoading = true;
    _.jobService
      .delete_job(_.jobToDelete)
      .then((data: any) => {
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  nextPageAction() {
    const _ = this;
    _.itemsOfTo = _.itemsOfTo + _.jobList.length;
    console.log(_.itemsOfTo, "incremento 1");
    _.itemsOfFrom = _.itemsOfFrom + _.jobList.length;
    console.log(_.itemsOfFrom, "incremento 2");
    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.get(_.pageOffset);

    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      console.log(_.nextPositionDisabled, "98898");
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (_.currentPage == 1) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo - _.jobList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.jobList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      console.log(_.nextPositionDisabled, "false");
      return;
    }
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }
}
